//@flow
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FullCustomCard from '../../components/FullCustomCard/FullCustomCard';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import { objectsConstants } from '../../_constants/objects.constants';
import { estabelecimentoFinanceiroService } from '../../_services/estabelecimentoFinanceiro.service';
import EstabelecimentoFinanceiroForm from './EstabelecimentoFinanceiroForm';




const defaultArrayItem = [{ idList: new Date().getTime() }];

class EstabelecimentoFinanceiroView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      entity: { status: true },
    };
  }

  componentDidMount() {
    this.loadUser();
  }



  loadUser = () => {
    if (this.props.match.params.id) {
      this.props.loading(true);
      estabelecimentoFinanceiroService.doGet(this.props.match.params.id).then(
        (response) => {
          let estabelecimentoFinanceiro = response.data;
          this.setState({ entity: _.cloneDeep(estabelecimentoFinanceiro) }, () => {
            this.props.loading(false);
          });
        },
        (error) => {
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  };

  render() {
    // let _this = this;
    const { entity } = this.state;
    const { ...otherPops } = this.props;
    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={entity && entity.nome}
          canBack={true}
          backUrl={'/estabelecimentoFinanceiro'}
        />

        <div className="flex-column mt-4">
          {entity && (
            <FullCustomCard
              title="Estabelecimento Financeiro"
              permissionSave={objectsConstants.CRUD_ESTABELECIMENTO_FINANCEIRO}
              Componente={EstabelecimentoFinanceiroForm}
              viewMode={true}
              entity={entity}
              onSave={this.loadUser}
              cancelForm={this.loadUser}
              {...otherPops}
            ></FullCustomCard>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  null,
  mapDispatch,
  null
)(withRouter(EstabelecimentoFinanceiroView));
